import React, { useContext, useRef, useState } from 'react'
import { useOutletContext } from 'react-router-dom'
import { Content } from './style'

import OccurencesTable from './OccurencesTable'
import ModalContext from '../../../contexts/ModalContext'
import { OccurrenceContext } from '../../../contexts/OccurrenceContext'
import { Header } from '../../../components/SubHeaderFilter/types'
import { usePersistedFilters } from '../../../hooks/usePersistedFilters'
import { PageHeader } from '../../../components/StandardPage'

interface TypeMainOutlet {
  search: string
}

const occurrenceHeaders: Header[] = [
  { key: 'id', label: 'ID', type: 'number' },
  { key: 'operationNumber', label: 'OP', type: 'string' },
  { key: 'companyName', label: 'Cliente', type: 'string' },
  { key: 'description', label: 'Descrição', type: 'string' },
  { key: 'allocation', label: 'Alocação', type: 'string' },
  { key: 'sector', label: 'Setor', type: 'string' },
  { key: 'stage', label: 'Etapa', type: 'string' },
  { key: 'relevant', label: 'Relevante', type: 'boolean' },
]

const OccurrencesContent: React.FC = () => {
  const { search } = useOutletContext<TypeMainOutlet>()
  const filtersState = usePersistedFilters('occurrences')
  const { setModalSection, setModalActive } = useContext(ModalContext)
  const { setOccurrence } = useContext(OccurrenceContext)

  const [refresh, setRefresh] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const hasInitializedRefresh = useRef(false)

  const handleNewOccurrence = () => {
    setOccurrence(null)
    setModalSection('createEditOccurrenceModal')
    setModalActive(true)
  }

  const triggerRefresh = () => {
    if (!hasInitializedRefresh.current) {
      hasInitializedRefresh.current = true
    }
    setRefresh((previous) => !previous)
  }

  return (
    <>
      <PageHeader
        title='Ocorrências'
        onReload={triggerRefresh}
        isLoading={isLoading}
        filterHeaders={occurrenceHeaders}
        appliedFilters={filtersState.appliedFilters}
        onApplyFilter={filtersState.handleApplyFilter}
        onRemoveFilter={filtersState.handleRemoveFilter}
        onClearAllFilters={filtersState.handleClearAll}
        createButton={{ label: 'Nova Ocorrência', onClick: handleNewOccurrence }}
      />
      <Content>
        <OccurencesTable
          search={search}
          appliedFilters={filtersState.appliedFilters}
          refresh={refresh}
          onRefreshStart={() => setIsLoading(true)}
          onRefreshEnd={() => setIsLoading(false)}
        />
      </Content>
    </>
  )
}

export default OccurrencesContent
